import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { incrementUser } from '../../redux/userSlice';
import { AxiosInstance } from '../../api/apiInstance';
import { ITaskStatus } from '../../interface/ITask';
import { incrementTask } from '../../redux/TaskStatusSlice';
import { incrementAllUsers } from '../../redux/AllUserSlice';
import { IPriorityProducts, ITaskType } from '../../interface/IOrders_Tasks';
import { incrementTaskType } from '../../redux/TaskTypeSlice';
import { incrementProducts } from '../../redux/ProductSlice';

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Compulock Power by Elogy Ltd
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function SignIn() {
  const dispatch = useDispatch()
  const [loginError, setLoginError] = React.useState('')
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const login = {
      usermail: data.get('email'),
      userPasswordEnc: data.get('password'),
    }

    const resLogin = await AxiosInstance.post('auth/login', login,{withCredentials: true,})
          .then(function (response) {
            setLoginError('');
            return response.data;
          })
          .catch(function (error) {
            
            setLoginError('Login Error');
            
          });
    if (resLogin === undefined) return;     
    dispatch( incrementUser(resLogin))
    const taskStatus = await AxiosInstance({
      // url of the api endpoint (can be changed)
      url: "task-status",
      method: "GET",
    }).then((res) => {
      // handle success
      return res.data as ITaskStatus[];
    }); 
    dispatch( incrementTask(taskStatus))
    const users: IUser[]= await AxiosInstance({
      // url of the api endpoint (can be changed)
      url: "users",
      method: "GET",
    }).then((res) => {
      // handle success
      return res.data;
    }); 
    dispatch( incrementAllUsers( users))
    const taskType: ITaskType[]= await AxiosInstance({
      // url of the api endpoint (can be changed)
      url: "/task-type",
      method: "GET",
    }).then((res) => {
      // handle success
      return res.data;
    }); 
    dispatch( incrementTaskType( taskType))

    const products: IPriorityProducts[]= await AxiosInstance({
      // url of the api endpoint (can be changed)     
      url: "/priorityProducts",
      method: "GET",
    }).then((res) => {
      // handle success
      return res.data;
    });     
    dispatch( incrementProducts( products))
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="user name"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
            <div style= {{color: 'red'}}>
            {loginError}
            </div>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>          
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}